import { registerQueryFilterLabels } from 'components/organisms/filters/query-form/labels/QueryFilterLabels';
import i18n from 'locales/i18n';
import { IContractSearch, PRODUCT_TYPE } from 'services/contract/types';

registerQueryFilterLabels<IContractSearch>(
  'contracts',
  {
    ProductType: ({ value }) =>
      value !== undefined && value !== null
        ? i18n.t(`enum.PRODUCT_TYPE.${PRODUCT_TYPE[value as PRODUCT_TYPE]}`)
        : null,

    ShowOnlyActive: ({ value }) => (value === true ? i18n.t('input.label.showOnlyActive') : null),
  },
  {
    ShowOnlyActive: ({ key, setValues }) => {
      setValues((prev) => ({ ...prev, [key]: false as any }));
    },
  },
);
